import React, { useEffect, useState } from 'react';
import { DataGrid } from "devextreme-react";
import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { useSelector } from 'react-redux';

import { cellRender, dataFormatId, formatId, padIdInfoData } from '../../utils/common';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { formatDate } from '../../data/app';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';

const dataGridRef = React.createRef();

const ReportBills = props => {

    console.log(props);

    const { params, name } = props;
    const { billPayment, appInfo } = useSelector(store => store);


    const [report, setReport] = useState([]);

    function exportGrid() {
        const doc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        exportDataGridToPdf({
            jsPDFDocument: doc,
            component: dataGrid
        }).then(() => {
            doc.save(`${name}.pdf`);
        });
    }

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a PDF',
                icon:'exportpdf',
                type:'danger',
                stylingMode:"outlined",
                onClick: exportGrid
            }
        },{
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'exportxlsx',
                type:'success',
                stylingMode:"outlined",
                onClick: () => dataGridRef.current.instance.exportToExcel(false)
            }
        });
    }  

    useEffect(() => {

        http(uri.reports.bills.get).asGet(params).then(resp => setReport(resp));
        
    }, [params]);

    const onCellPrepared = e => {
                    
            if(e.column.dataField == 'id')
                e.cellElement.classList.add('col-id-factura');  
        
    
    }

    const padId = padIdInfoData(appInfo);


    return (
        <div>              
            <DataGrid
                id="gridContainer"
                ref={dataGridRef}
                dataSource={report}
                showBorders={true}
                showRowLines={true}
                onToolbarPreparing={onToolbarPreparing}
                onCellPrepared={onCellPrepared}
            >                        
                <Column dataField="numberBill" caption="Factura #" width={85} cellRender={padId}/>
                <Column dataField="date" dataType="date" caption="Fecha" format={formatDate} width={95} />
                <Column dataField="name" caption="Cliente" />
                <Column dataField="type" caption="Tipo" width={70} />
                <Column dataField="createBy" caption="Vendedor"  width={110}/>
                <Column dataField="total" caption="Total" cellRender={cellRender()} width={100} alignment="right" />                    
                <Summary>
                    <TotalItem
                        column="total"
                        summaryType="sum" />
                </Summary>
            </DataGrid>        
        </div>
    );
}

export default ReportBills;
